// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Cache: Record<string, any> = {};
